export default __webpack_public_path__ + "static/media/safebox.31ca7766.svg";